import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import compose from 'lodash.flowright';
import { useQuery } from 'react-apollo';

import { CUSTOM_PRINT_TYPE } from '../../../../../../../constants/pro-custom-prints';
import { getAlbumCustomPrintName } from '../../../../../../../util/custom-prints';
import { getPurchasedCustomPrintForConfigQuery } from '../../../../../../temp/views/memberships/AlbumMembershipGroup/graphql/queries/getPurchasedCustomPrintsForConfig';
import Angle from '../../../../../../../components/global/Angle';
import CustomPrintBadge from '../../../../../../temp/components/CustomPrintBadge';
import usePurchasesPendingConfiguration from '../PurchasesPendingConfiguration/hooks/usePurchasesPendingConfiguration';

const propTypes = {
  purchasedCustomPrint: PropTypes.shape({
    id: PropTypes.string,
    custom_print: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      type: PropTypes.oneOf(Object.values(CUSTOM_PRINT_TYPE)),
    }),
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      hierarchyItemId: PropTypes.string,
    }),
  }),
};

const PurchasedCustomPrintConfigNotice = ({ match }) => {
  const { hierarchyItem } = usePurchasesPendingConfiguration({
    hierarchyItemId: match?.params?.hierarchyItemId,
  });

  const supportsPrepaidCustomPrints =
    hierarchyItem?.album?.root_album_folder?.prepaid_custom_prints_enabled ||
    hierarchyItem?.album_folder?.root?.prepaid_custom_prints_enabled;

  const { data: { albumMembershipGroup } = {} } = useQuery(
    getPurchasedCustomPrintForConfigQuery,
    {
      variables: {
        id: match?.params?.hierarchyItemId,
      },
      skip:
        !match?.params?.hierarchyItemId ||
        !hierarchyItem ||
        supportsPrepaidCustomPrints,
      fetchPolicy: 'network-only',
    },
  );

  const purchasedCustomPrint = useMemo(
    () => albumMembershipGroup?.purchased_custom_prints?.records?.[0],
    [albumMembershipGroup],
  );

  if (!purchasedCustomPrint || !hierarchyItem) {
    return null;
  }

  // This types of albumFolders would handle differently, so remove this notice.
  if (supportsPrepaidCustomPrints) {
    return null;
  }

  const name = getAlbumCustomPrintName(purchasedCustomPrint);

  return (
    <Link
      className="purchased-custom-print-config-notice"
      to="/consumer/custom-prints/redirect"
    >
      <CustomPrintBadge />
      Configure your {name} <Angle direction="right" />
    </Link>
  );
};

PurchasedCustomPrintConfigNotice.propTypes = propTypes;

export default compose(withRouter)(PurchasedCustomPrintConfigNotice);
